import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import "regenerator-runtime/runtime";
import GetGlobalRouter from "Global/AppRouter";
import { BrowserRouter } from "react-router-dom";
import NGI_Reducer from "Global/store/NGI_Reducer";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { ErrorBoundary } from "react-error-boundary";
import { setPrefix } from "react-id-generator";
import "bootstrap/dist/css/bootstrap.min.css";
import "Common/css/common.css";
import "Common/css/Footer.css";
import "Common/css/navbar.css";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "authConfig";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { enableMapSet } from "immer";
import AuthorizationComponent from "Authorization/components/AuthorizationComponent";

enableMapSet();
setPrefix("main-");

const store = configureStore({
  reducer: NGI_Reducer,
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <div>
        <MsalProvider instance={msalInstance}>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
          >
            <ErrorBoundary>
              <AuthorizationComponent>
                <GetGlobalRouter />
              </AuthorizationComponent>
            </ErrorBoundary>
          </MsalAuthenticationTemplate>
        </MsalProvider>
      </div>
    </BrowserRouter>
  </Provider>
);
